module.exports = {
  carMission: ['자동', '수동'],
  carfuel: ['', '가솔린', '경유', '가스', '전기', '하이브리드']
}
